
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/healthplus/Japanese-kampo-supplement",
      function () {
        return require("private-next-pages/brands/healthplus/Japanese-kampo-supplement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/healthplus/Japanese-kampo-supplement"])
      });
    }
  